<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <Sidebar :toggler.sync="isToggled" />
      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getUserProfile" />

      <Campaigns />
    </div>

    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';

import Sidebar from '@/components/Navigations/Sidebar';
import TopNavbar from '@/components/Navigations/TopNavbar';
import Campaigns from '@/components/Admin/Campains/Campains';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    Sidebar,
    TopNavbar,
    Campaigns,
  },
  mixins: [toggleSidebarNav],
  data: () => ({
    isToggled: false,
  }),
  methods: {
    ...mapActions(['retrieveUserProfile']),
  },
  computed: {
    ...mapGetters(['getUserProfile']),
  },
  mounted() {
    this.retrieveUserProfile();
  },
};
</script>
